import React, { useEffect, useState } from 'react';
import styles from './JobseekerProfileEmployerViewBody.module.css';
import { getTimeAgo } from '../../../../utils/formatHelpers';
import { useTranslation } from 'react-i18next';
import {
    BriefcaseWhite,
    Clock,
    LicenseIcon,
    LocationBlue,
    MortarboardWhite,
    OverViewBG,
    VisaIcon,
} from '../../../../assets/images/icons';
import { useGetJobCategoriesHook } from '../../../../utils/utilityHooks';
import { useSelector } from 'react-redux';

function OverView({ jobseeker, setHandleBlur, ref }) {
    const { t } = useTranslation();
    const [overViewData, setOverViewData] = useState([])
    const user = useSelector(state => state.user.user);

    useEffect(() => {
        const arr = []
        if (jobseeker?.country) {
            arr.push({ title: t('overview.currentLocation'), description: t('general.country.' + jobseeker?.country), icon: LocationBlue })
        }
        if (jobseeker?.city) {
            arr.push({ title: t('general.UI.City'), description: t('general.city.' + jobseeker?.city), icon: LocationBlue })
        }
        if (jobseeker?.employer_status !== "individual") {
            arr.unshift({ title: t('employer.website'), description: jobseeker?.company_website, icon: LocationBlue, isLink: true },)
        }

        if (jobseeker?.driving_license) {
            arr.push(
                {
                    title: t('overview.drivingLicense'),
                    description: jobseeker?.driving_license,
                    icon: LicenseIcon,
                    isLink: true
                }
            )
        }
        if (jobseeker?.visa_status) { arr.push({ title: t('overview.visaStatus'), description: jobseeker?.visa_status, icon: VisaIcon }) }
        setOverViewData(arr)
    }, [jobseeker])

    let last_seen = '';
    let is_online = false;
    const date_info = getTimeAgo(new Date(jobseeker?.last_visit));
    if (date_info.unit_plural !== 'month' && date_info.unit_plural !== 'months' && date_info.unit_plural !== 'year' && date_info.unit_plural !== 'years') {

        if (date_info.unit_plural === 'second' || date_info.unit_plural === 'seconds' || date_info.unit_plural === 'minute' || (date_info.unit_plural === 'minutes' && date_info.count < 5)) {
            last_seen = t('general.UI.online');
            is_online = true;
        }
        else {
            last_seen = date_info.count + ' ' + t('general.UI.' + date_info.unit_plural) + ' ' + t('general.UI.ago');
        }

    }
    let occupationOptions = useGetJobCategoriesHook();
    // let occupations = [];
    const [occupations, setOccupation] = useState([])
    useEffect(() => {
        getOccupationData()
    }, [occupationOptions, jobseeker])
    const getOccupationData = async () => {
        let data;
        if (jobseeker?.occupations?.length > 0 && occupationOptions?.length > 0) {
            data = await jobseeker.occupations.map((occupation) => {
                let response = occupationOptions.filter((e) => e.id.toString() == occupation.occupation_code)
                if (response.length > 0) {
                    return {
                        id: Date.now() + '-' + occupation.occupation_code,
                        occupation_code: response[0].id,
                        name: response[0].label
                    }
                }
            })
            // occupations = data
            setOccupation(data.slice(0, 2))
        }
    }
    const BUISNESSPROFILE = [
        {
            title: t('employer.industry'),
            description: jobseeker?.company_industries,
            icon: BriefcaseWhite,
        },
        {
            title: t('employer.company_size'),
            description: jobseeker?.company_size ? jobseeker?.company_size : 1,
            icon: MortarboardWhite,
        },
        { title: t('overview.lastActive'), description: last_seen, icon: Clock },
    ]
    const INDIVIDUALPROFILE = [{
        title: t('general.UI.occupations'),
        description: jobseeker?.occupations,
        icon: BriefcaseWhite,
    },
    {
        title: t('personalInformation.nationality'),
        description: t('general.nationality.' + jobseeker?.nationality),
        icon: MortarboardWhite,
    },
    { title: t('overview.lastActive'), description: last_seen, icon: Clock },

    ]
    const data = jobseeker?.employer_status == "individual" ? INDIVIDUALPROFILE : BUISNESSPROFILE
    return (
        <div ref={ref} id='aboutMe' className={`${styles.overViewContainer}`}  >
            <h2 className={styles.heading}>{t('overview.heading')}</h2>
            {/* if (jobseeker?.employer_status=="individual") { */}
            {data
                .filter(Boolean)
                .map((item, index) => {
                    return (
                        <div className={styles.block} key={index}>
                            <div className={styles.iconContainer}>
                                <img
                                    className={styles.overViewIcon}
                                    src={item.icon}
                                    alt={item.title}
                                />
                            </div>
                            <div className={styles.blockBody}>

                                <p
                                    className={styles.description}
                                    style={{ textAlign: "left" }}
                                >
                                    {item.title}
                                </p>
                                {Array.isArray(item.description) ? (
                                    occupations && occupations?.map((lang, index) => {
                                        return (
                                            <p className={styles.descriptionBold} key={index}>
                                                {lang?.name}{index == occupations?.length - 1 ? '' : ", "}
                                            </p>
                                        )
                                    })
                                ) : (
                                    <p className={styles.descriptionBold}>
                                        {item.description}
                                    </p>
                                )}
                            </div>
                        </div>
                    );
                })}
            <div className={styles.hrline} />
            {overViewData.map((item, index) => {
                return (
                    <div className={styles.block} key={index}>
                        <div className={styles.iconContainerLight}>
                            <img
                                className={styles.overViewIcon}
                                src={item.icon}
                                alt={item.title}
                            />
                        </div>
                        <div className={styles.blockBody}>
                            <p
                                className={styles.description}
                                style={{ textAlign: "left" }}
                            >
                                {item.title}
                            </p>
                            {item.isLink && item.description ? (
                                <p className={styles.descriptionBold}>
                                    <a
                                        onClick={() => {
                                            if (user?.verification_status === 'approved' && user?.subscriptionStatus == 'active') { } else {
                                                if (user?.account_type !== 'employer') {
                                                    setHandleBlur(true)
                                                } else {
                                                    if (user?.subscriptionStatus == 'active') { }
                                                    else { setHandleBlur(true) }
                                                }
                                            }
                                        }}
                                        href={user?.account_type !== 'employer' ? user?.verification_status === 'approved' && user?.subscriptionStatus == 'active' ? item.description : "#" : user?.subscriptionStatus == 'active' ? item.description : "#"}
                                        target={user?.account_type !== 'employer' ? user?.verification_status === 'approved' && user?.subscriptionStatus == 'active' ? '_blank' : '_parent' : user?.subscriptionStatus == 'active' ? item.description : "#"}
                                        rel="noopener noreferrer"
                                    >
                                        {item.description}
                                    </a>
                                </p>
                            ) : (
                                <p className={styles.descriptionBold}>{item.description}</p>
                            )}
                        </div>
                    </div>
                );
            })}
            <img className={styles.overViewBG} src={OverViewBG} alt="Overview Background" />
        </div >
    );
}

export default OverView;
